import script from "./Answers.vue?vue&type=script&setup=true&lang=js"
export * from "./Answers.vue?vue&type=script&setup=true&lang=js"

import "./Answers.vue?vue&type=style&index=0&id=19ea1411&lang=scss&scoped=true"

import exportComponent from "D:\\psy\\项目\\guofang\\oldgfzs\\home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ea1411"]])

export default __exports__